export default __webpack_public_path__ + "15369f68606cbad75142ef53c0fe5f9c.png";